import React, { useCallback, useEffect, useState, createRef, forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { api } from '../../../../../../api';
import './styles.scss';

const EditUserTimerModal = ({ setError, data, onClose }) => {

  const [email, setEmail] = useState("");
  const [timeInit, setTimeInit] = useState("");
  const [timeEnd, setTimeEnd] = useState("");
  const [betaAtivo, setBetaAtivo] = useState("");

  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const { formatMessage: f } = useIntl();

  let timeInput = createRef();

  const dateInit = new Date();
  const dateFinish = new Date();
  dateFinish.setMonth(dateFinish.getMonth() + 12);

  const formatDate = (data) => {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };
  
  const handleBetaUserUpdate = e => {
    e.preventDefault();

    setLoading(true);
    api
      .post("/users/add_beta_user", {
        email: email,
        data_inicio: timeInit,
        data_fim: timeEnd,
        ativo: betaAtivo
      })
      .then(res => {
        alert('Cadastro Atualizado com sucesso!');
        onClose();
      })
      .catch(error => {
        setErrorMessage(error.response.data.message || f({ id: "erro-api" }));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getBetaInfo = useCallback(() => {
    api.get(`/users/get_beta_user?email=${encodeURIComponent(data)}`)
      .then(({data: response}) => {
        if(response.B3BetaUser){
          setEmail(response.B3BetaUser.email);
          setBetaAtivo(response.B3BetaUser.ativo);
          if(response.B3BetaUser.data_inicio){
            const dataInit = response.B3BetaUser.data_inicio.split(" ")[0];
            const [dia, mes, ano] = dataInit.split(".");
            const data_inicio_formatada = `${dia}-${mes}-${ano}`;
            setTimeInit(data_inicio_formatada);
          }
          if(response.B3BetaUser.data_fim){
            const dataEnd = response.B3BetaUser.data_fim.split(" ")[0];
            const [dia, mes, ano] = dataEnd.split(".");
            const data_fim_formatada = `${dia}-${mes}-${ano}`;
            setTimeEnd(data_fim_formatada);
          }
        }
        else {
          setErrorMessage(f({ id: "usuario-nao-beta" }));
          setEmail(data);
          setTimeInit(formatDate(dateInit));
          setTimeEnd(formatDate(dateFinish));
          setBetaAtivo(true);
        }

        setLoading(false);
      })
      .catch(() => {
        setError(formatMessage({ id: "erro-api" }));
        setLoading(false);
      });
  }, [data, formatMessage, setError]);

  useEffect(() => {
    timeInput.current && timeInput.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getBetaInfo();
  }, [getBetaInfo]);

  return (
    <div className="modal edit-user-timer-modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <div className="modal-card-title">
            {errorMessage ? (
              <div className="auth-error-message">{errorMessage}</div>
            ) : (
              <div className="auth-error-message-spacer">{f({ id: "user-tempo" })}</div>
            )}
          </div>
        </header>
        <section className="modal-card-body">
          <div className="input-container">
            <input
              type="email"
              name="email"
              placeholder="E-mail"
              value={email}
              disabled
            />
            <label htmlFor="email">E-mail</label>
          </div>

          <div className="input-container">
            <input
              ref={timeInput}
              type="timer"
              name="timeInit"
              placeholder={f({ id: "user-tempo-inicio" })}
              value={timeInit}
              required
              onChange={e => setTimeInit(e.target.value)}
            />
            <label htmlFor="timeInit">{f({ id: "user-tempo-inicio" })}</label>
          </div>

          <div className="input-container">
            <input
              type="timer"
              name="timeEnd"
              placeholder={f({ id: "user-tempo-final" })}
              value={timeEnd}
              required
              onChange={e => setTimeEnd(e.target.value)}
            />
            <label htmlFor="timeEnd">{f({ id: "user-tempo-final" })}</label>
          </div>

          <div className="input-user">
            <span>
              {f({ id: "cadastro-beta-ativo" })}
            </span>
            <input
              type="checkbox"
              checked={betaAtivo}
              onChange={e => setBetaAtivo(e.target.checked)}
            />
          </div>

        </section>
        <footer className="modal-card-foot">
          <button
            className="button danger"
            onClick={onClose}
          >
            {formatMessage({ id: "cancelar" })}
          </button>

          <button
            className={`button primary ${loading ? "is-loading" : ""}`}
            onClick={handleBetaUserUpdate}
          >
            {formatMessage({ id: "atualizar-cadastro" })}
          </button>
        </footer>
      </div>
    </div>
  )
}

const DatePickerCustom = forwardRef((props, ref) => (
  <input className="date-picker-custom" {...props} ref={ref} />
));

export default EditUserTimerModal;